// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { Amplify, defaultStorage } from '@aws-amplify/core';
import { readFile } from '../utils/readFile';
import { toBase64 } from '../utils/toBase64';
import { uploadData as uploadDataInternal } from '../../providers/s3/apis/internal/uploadData';
export function uploadData(input) {
    return uploadDataInternal({ amplify: Amplify, readFile, toBase64 }, {
        ...input,
        options: {
            ...input?.options,
            // This option enables caching in-progress multipart uploads.
            // It's ONLY needed for client-side API.
            resumableUploadsCache: defaultStorage,
        },
    });
}
